import { render, staticRenderFns } from "./TaskRTWCTemplate.vue?vue&type=template&id=2eaf223e&scoped=true&lang=pug"
import script from "./TaskRTWCTemplate.vue?vue&type=script&lang=ts"
export * from "./TaskRTWCTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaf223e",
  null
  
)

export default component.exports